import FormHelperText from '@mui/material/FormHelperText'
import { TextFieldProps } from '@mui/material/TextField'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup, { ToggleButtonGroupProps } from '@mui/material/ToggleButtonGroup'
import { capitalCase } from 'change-case'
import type { ReactNode } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export interface RHFToggleButtonProps extends Partial<ToggleButtonGroupProps> {
  name: string
  options?: string[] | ToggleButtonOption[]
  children?: ReactNode
}

interface ToggleButtonOption {
  label: ReactNode
  value: any
}

export function RHFToggleButton({ name, children, options, ...other }: RHFToggleButtonProps & TextFieldProps) {
  const { t } = useTranslation()
  const { control } = useFormContext()

  if (options) {
    if (typeof options[0] === 'string') {
      children = options.map(option => (
        <ToggleButton key={option} value={option}>
          {capitalCase(t(option) as string)}
        </ToggleButton>
      ))
    } else {
      children = options.map(option => (
        <ToggleButton key={option.value} value={option.value}>
          {capitalCase(t(option.label) as string)}
        </ToggleButton>
      ))
    }
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, onChange: RHFonChange, ...field }, fieldState: { error } }) => (
        <>
          <ToggleButtonGroup exclusive onChange={RHFonChange} {...field} {...other}>
            {children}
          </ToggleButtonGroup>
          {!!error && (
            <FormHelperText error sx={{ px: 2 }}>
              {error.message}
            </FormHelperText>
          )}
        </>
      )}
    />
  )
}
